import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { category as CategoryApi } from "@teem/constants/api";

@Injectable({
	providedIn: 'root'
})

export class CategoryService {

	constructor(
		private httpClient: HttpClient
	) { }

	getAllCategories() {
		return this.httpClient.get(CategoryApi.all);
	}

	getProductCategory() {
		return this.httpClient.get(CategoryApi.productCategories);
	}

	getServiceCategory() {
		return this.httpClient.get(CategoryApi.serviceCategories);
	}
}
